import { Cart } from '../cart/cart';
import Address from '../user/address';
import User from '../user/user';

export default class Budget {
  addressDelivery?: Address;
  addressInvoicing?: Address;
  additionalValue?: number;
  availableCredit?: number;
  carrier?: string;
  carrierDescription?: string;
  cart?: Cart;
  createdAt?: string;
  creatorUser?: User;
  deliveryTime?: number;
  discountSeller?: number;
  hash?: string;
  id?: number;
  observations = '';
  status?: string;
  updatedAt?: string;
  user?: User;
  userLead = false;
  valueFreight?: number;
  volume?: number;
}
